import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib';
import {
  cancelCheckinAcceptanceResultRequest,
  failCheckinAcceptanceResult,
  setCheckinAcceptanceResult,
  setCheckinAcceptanceResultFromApi,
  updateCheckinAcceptanceResult,
  updateCheckinAcceptanceResultFromApi,
} from './checkin-acceptance-result.actions';

/**
 * Service to handle async CheckinAcceptanceResult actions
 */
@Injectable()
export class CheckinAcceptanceResultEffect {
  /**
   * Set the state with the reply content, dispatch failCheckinAcceptanceResult if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setCheckinAcceptanceResultFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setCheckinAcceptanceResult({ checkinAcceptanceResult: reply, requestId: action.requestId }),
        (error, action) => of(failCheckinAcceptanceResult({ error, requestId: action.requestId })),
        cancelCheckinAcceptanceResultRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failCheckinAcceptanceResult if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateCheckinAcceptanceResultFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) =>
            updateCheckinAcceptanceResult({ checkinAcceptanceResult: reply, requestId: payload.requestId })
          ),
          catchError((err) => of(failCheckinAcceptanceResult({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
